import type { AvatarStackItem } from "@/components/projects/cards/AvatarStack";
import type { PlainOrganizationMember } from "@/queries/organization-queries";
import type { Group } from "gitpod-next-api/gitpod/v1/group_pb";

// Helper functions for mapping to AvatarStackItem
export const groupToStackItem = (group: Group): AvatarStackItem => ({
    id: group.id,
    name: group.name,
    shape: "square",
});

export const userToStackItem = (user: PlainOrganizationMember): AvatarStackItem => ({
    id: user.userId,
    name: user.fullName,
    avatarUrl: user.avatarUrl,
    shape: "circle",
});
